import styled from 'styled-components';
import { parseProp, parseTheme } from 'mol-ui';

export const DownloadContainer = styled.div`
    ${ parseProp('margin') }
    a {
        ${ parseProp('color') }
        font-size: 12px;
    }
`;

export const InstructionsContainer = styled.ul`
    width: 100%;

    li {
        ${ parseTheme('color', 'textColor') }
        font-size: 12px;
    }
`;
